import CardForm from './card-form'
import GameLoading from './loading'
import NotFound from '../notfound'
import Phases from './phases'
import React, { PropTypes } from 'react'
import {updateGame} from 'app/actions/game'
import {Socket} from 'phoenix/web/static/js/phoenix'

const GameShow = React.createClass({

  statics: {
    query(state, props) {
      return {
        game        : state.game,
        shortcode   : props.params.game,
        isFunmaster : props.location.query.fm == 1
      }
    }
  },

  propTypes: {
    game      : PropTypes.object.isRequired,
    shortcode : PropTypes.string.isRequired
  },

  getInitialState() {
    let socket = new Socket("/socket", { params: { token: window.userToken } })

    return {
      socket  : socket,
      channel : socket.channel('games:' + this.props.shortcode, {}),
      missing : false,
      time    : 0,
      status  : 'Unknown'
    }
  },

  componentWillUnmount() {
    this.state.socket.disconnect()
  },

  channelDidConnect(payload) {
    console.log("Channel opened")
    this.gameDidUpdate(payload)
  },

  channelDidFail(response) {
    console.log("Unable to join:", response)
    this.setState({ missing: true })
  },

  gameDidUpdate(payload) {
    this.props.app.push(updateGame, payload.data)
  },

  componentDidMount() {
    let { app, shortcode }  = this.props
    let { socket, channel } = this.state

    socket.connect()

    channel.join()
           .receive("ok", this.gameDidUpdate)
           .receive("error", this.channelDidFail)

    channel.on("game_updated", this.gameDidUpdate)
  },

  cardGuessed(card_id) {
    this.state.channel.push("card_guessed", {})
  },

  nextPhase() {
    this.state.channel.push("next_phase", {})
  },

  createCard(body) {
    this.state.channel.push("add_card", body)
  },

  onPlayerCheated() {
    this.state.channel.push("cheated")
  },

  render() {
    let { game, isFunmaster } = this.props
    let { channel, missing } = this.state

    if (missing) {
      return (<NotFound resource="Game" />)
    }

    if (game.loading) {
      return (<GameLoading />)
    }

    return (<Phases game={ game }
                    isFunmaster={ isFunmaster }
                    onCheated={ this.onPlayerCheated }
                    onCreateCard={ this.createCard }
                    onGuess={ this.cardGuessed }
                    onNext={ this.nextPhase } />)
  }

})

export default GameShow



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/show.jsx
 **/